/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	// services
	'./dataSources/services/DatasetExecutionService',
	'./drill-through/models/DrillThroughService',
	'./drill-through/models/DrillThroughModel',
	'./dataSources/models/synchronizeData/SynchronizeService',

	// navbar contributions
	'./dataSources/glassControllers/SourceActionHandler',
	'./dataSources/glassControllers/AddSourceActionHandler',
	'./visualizations/LiveVisualizationActionHandler',

	// filter dock contributions
	'./filters/dock/FilterContainerView',
	'./filters/dock/FilterContainerCollapseView',
	'./dialogs/CommonViewWrapper',

	// datasource panel contributions
	'./dataSources/views/DataSourcePanel',

	// colorSet extension
	'./util/AnalyticsColorSet'
], function() {
	'use strict';
});
